import MissingPermissionsContent from './MissingPermissionsContent';

export default MissingPermissionsContent;
